import React from 'react';

const Home = () => {
  return null;
};

export default Home;